import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_API_BASE_URL;

// Axios instance with base URL
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Automatically attach JWT token
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear auth data
      const Cookies = require("js-cookie").default;
      Cookies.remove("auth_token");
      Cookies.remove("user");
      // Redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

/**
 * Send all data (sales Header&Lines) from our platform and inserted into another platform
 * @param {string} username - The username of the logged-in user
 */
export const sendData = async () => {
  try {
    const res = await axiosInstance.post("/WindowsSrvc/SendHeadersToKatNav");
    return res.data;
  } catch (err) {
    console.error("Error sending data:", err);
    throw err;
  }
};

/**
 * Get all data (sales Header&Lines) from another platform and inserted into our platfrom
 */
export const getData = async () => {
  try {
    const res = await axiosInstance.get("/Mobile/GetData");
    return res.data;
  } catch (err) {
    console.error("Error fetching data:", err);
    throw err;
  }
};

/**
 * Get all items from another platform and inserted into our platfrom
 */
export const getItems = async () => {
  try {
    const res = await axiosInstance.get("/Mobile/Synchronize");
    return res.data;
  } catch (err) {
    console.error("Error fetching items:", err);
    throw err;
  }
};

/**
 * Get all items unit of measure from another platform and inserted into our platfrom
 */
export const getIUOM = async () => {
  try {
    const res = await axiosInstance.get("/Mobile/Synchronize");
    return res.data;
  } catch (err) {
    console.error("Error fetching items unit of measure:", err);
    throw err;
  }
};

/**
 * Get all items cross reference from another platform and inserted into our platfrom
 */
export const getICR = async () => {
  try {
    const res = await axiosInstance.get("/Mobile/GetItemCrossReference");
    return res.data;
  } catch (err) {
    console.error("Error fetching items cross reference:", err);
    throw err;
  }
};

/**
 * Get all stock from another platform and inserted into our platfrom
 */
export const syncStock = async () => {
  try {
    const res = await axiosInstance.post("/WindowsSrvc/GetStock");
    return res.data;
  } catch (err) {
    console.error("Error synchronizing stock:", err);
    throw err;
  }
};

/**
 * Get stock from out platform
 */
export const getStock = async () => {
  try {
    const res = await axiosInstance.get("/Stock/GetStock");
    return res.data;
  } catch (err) {
    console.error("Error fetching stock:", err);
    throw err;
  }
};

/**
 * Get all customers from another platform and inserted into our platform
 */
export const getCustomers = async () => {
  try {
    const res = await axiosInstance.get("/Mobile/GetCustomers");
    return res.data;
  } catch (err) {
    console.error("Error fetching customers:", err);
    throw err;
  }
};
